import { push } from "connected-react-router";

import { getPollsList, changePollVisibility } from '../../request';
import { checkAndRenewTokens, checkTokenError } from "./auth";
import { clearPollForm } from "./editPoll";
import { showErrorMessage, hideErrorMessage, showSuccessMessage } from "./ui";

//Загрузка списка опросов
export const POLLS_LOADING_START = "Polls list loading start";
export const POLLS_LOADING_SUCCESS = "Polls list loading success";
export const POLLS_LOADING_FAILED = "Failure during polls list load";

//Восстановление отчета
export const POLL_RESTORE_START = "Poll restore start";
export const POLL_RESTORED_SUCCESSFULLY = "Poll restored successfully";
export const POLL_RESTORE_FAILED = "Failure during poll restore";

//Фильтры
export const SWITCH_POLLS_FILTER = "Switch polls filter";

//Пагинация
export const CHANGE_POLLS_PAGE = "Change polls page";
export const CHANGE_POLLS_LIMIT = "Change polls limit";

const startLoading = () => ({
  type: POLLS_LOADING_START
});

const loadSuccess = polls => ({
  type: POLLS_LOADING_SUCCESS,
  payload: {
    polls: polls || []
  }
});

const loadFailure = () => ({
  type: POLLS_LOADING_FAILED,
});


//Загрузка списка опросов
export const getPollsListAsync = payload => {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    let polls;
    try {
      const accessToken = localStorage.getItem("accessToken");
      polls = await getPollsList(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке списка опросов!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(polls));
  };
};

export const goToPollCreation = () => {
  return async (dispatch) => {
    dispatch(clearPollForm());
    dispatch(push('/create-poll'));
  };
};

//Пагинация на странице списка опросов
export const changePollsPage = activePage => ({
  type: CHANGE_POLLS_PAGE,
  payload: { activePage }
});

//Отображение элементов на странице списка опросов
export const changePollsLimit = activeLimit => ({
  type: CHANGE_POLLS_LIMIT,
  payload: { activeLimit }
});

//Фильтры
export const switchPollsFilter = filter => ({
  type: SWITCH_POLLS_FILTER,
  payload: {
    filter,
  }
});

//ВОССТАНОВЛЕНИЕ ОТЧЕТА
const startRestore = () => ({
  type: POLL_RESTORE_START
});

const restoreSuccess = (status, pollIndex) => ({
  type: POLL_RESTORED_SUCCESSFULLY,
  payload: { status, pollIndex },
});

const restoreFailure = () => ({
  type: POLL_RESTORE_FAILED,
});

export const restorePollAsync = (status, pollId, pollIndex) => { 
  return async (dispatch) => {
    dispatch(startRestore());
    await dispatch(checkAndRenewTokens());
    const data = { status };
    try {
      const accessToken = localStorage.getItem("accessToken");
      await changePollVisibility(accessToken, data, pollId);
    } catch (err) {
      dispatch(showErrorMessage("Ошибка при восстановлении опроса"));
      dispatch(checkTokenError(err));
      return dispatch(restoreFailure());
    }
    dispatch(showSuccessMessage('Опрос восстановлен'));
    return dispatch(restoreSuccess(status, pollIndex));
  };
};

